module.exports = __webpack_public_path__ + "img/newsImg11-23.cd9f525a.png";